// extracted by mini-css-extract-plugin
export default {"container":"Section_container__dgvfk","title":"Section_title__6axmg","titleContainer":"Section_titleContainer__ASKZ6"};